import * as React from 'react'
import styled from 'styled-components'

interface Props {
  value: number
  steps?: number
  minValue?: number
  maxValue?: number
  onSelect?: (count: number) => void
  hidden?: boolean
  style?: any
  customQuantities?: Number[]
}

const QuantitiySelect = (props: Props) => {
  const { hidden, value, minValue, maxValue, steps, onSelect, style, customQuantities } = props
  var options = []
  let incr = minValue || 1
  while (incr <= (maxValue || 10)) {
    options.push(incr)
    incr += steps || 1
  }
  if(customQuantities) options = customQuantities;
  return (
    <Select
      id='quantity'
      hidden={hidden}
      value={value}
      key={value}
      onChange={(e) => onSelect(e.target.value)}
      style={style}>
      {options.map((o) => {
        return <option key={o}>{o}</option>
      })}
    </Select>
  )
}

const Select = styled.select`
  ${(props) => props.hidden && 'display: none;'}
  position: absolute;
  width: 54px;
  height: 27px;
  left: 150px;
  bottom: 15px;
  padding: 0 7.5px;
  appearance: none;
  border: 2px solid #9abbbf;
  border-radius: 0;
  outline: none;
  background: transparent;
  cursor: pointer;
  color: #4a4a4a;
  font-weight: 600;
  text-align: center;
  background-image: linear-gradient(45deg, transparent 50%, #4a4a4a 50%),
    linear-gradient(135deg, #4a4a4a 50%, transparent 50%),
    linear-gradient(to right, transparent, transparent);
  background-position: calc(100% - 10px) calc(1em - 3px),
    calc(100% - 5px) calc(1em - 3px), 100% 0;
  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
  background-repeat: no-repeat;
`

export default QuantitiySelect



// WEBPACK FOOTER //
// ./src/components/atoms/configurator/QuantitySelect.tsx